import { Column, Entity, PrimaryGeneratedColumn } from "typeorm";

@Entity("questiontype")
export class QuestionType {
  @PrimaryGeneratedColumn({ type: "int", name: "id" })
  id: number;

  @Column("text", { name: "questiontype", nullable: true })
  questiontype: string | null;

  @Column("tinyint", { name: "estatus", default: () => "'1'" })
  estatus: number;

  @Column("varchar", { name: "timestamp", length: 20, default: () => "''" })
  timestamp: string;

  @Column("int", { name: "orderid", default: () => "'0'" })
  orderid: number;
}
